import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { StaticQuery, graphql } from 'gatsby'
import classnames from 'classnames'
import { useWindowScroll } from 'react-use'

import HeaderItems from './HeaderItems'
import HeaderLogo from './HeaderLogo'
import HeaderToggle from './HeaderToggle'

import styles from '../../styles/components/Header/Header.module.css'
import HeaderContext from './HeaderContext'
import { HeaderClose } from './HeaderClose'

const Header = props => {
  const { y } = useWindowScroll()
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [isFixed, setIsFixed] = useState(false)
  const [sections, setSections] = useState(null)
  const [activeSection, setActiveSection] = useState(props.allMarkdownRemark.nodes[0].id)
  const context = {
    isFixed,
    sections,
    activeSection,
    isMenuOpen,
    onToggleClick: () => setIsMenuOpen(!isMenuOpen)
  }

  const headerClassName = classnames(styles.container, {
    [styles.containerActive]: isFixed
  })

  useEffect(() => {
    setIsFixed(y > 50)
  }, [y])

  useEffect(() => {
    if (!sections) {
      setSections(
        props.allMarkdownRemark.nodes.map(({ frontmatter: data }) =>
          document.getElementById(data.id)
        )
      )
    }
  }, [y])

  useEffect(() => {
    if (sections) {
      const closestSection = sections.filter(Boolean).sort((sectionA, sectionB) => {
        return Math.abs(y - sectionA.offsetTop) - Math.abs(y - sectionB.offsetTop)
      })[0]

      if (closestSection !== activeSection) {
        setActiveSection(closestSection.id)
      }
    }
  }, [sections, y])

  return (
    <HeaderContext.Provider value={context}>
      <header className={headerClassName}>
        <nav className={styles.nav}>
          <HeaderLogo />
          <HeaderToggle />
          <HeaderClose />
          <HeaderItems />
        </nav>
      </header>
    </HeaderContext.Provider>
  )
}

Header.propTypes = {
  allMarkdownRemark: PropTypes.shape({
    nodes: PropTypes.arrayOf(
      PropTypes.shape({
        frontmatter: PropTypes.shape({
          id: PropTypes.string.isRequired,
          title: PropTypes.string.isRequired,
          menuTitle: PropTypes.string
        })
      })
    )
  })
}

const headerQuery = graphql`
  query HeaderQuery {
    allMarkdownRemark(sort: { fields: frontmatter___menuOrder }) {
      nodes {
        frontmatter {
          id
          title
          menuTitle
        }
      }
    }
  }
`

export default () => <StaticQuery query={headerQuery} render={data => <Header {...data} />} />
